var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CButton',_vm._g({staticClass:"btn-block btn-google",attrs:{"text":_vm.text}},_vm.$listeners),[_c('i',{staticClass:"fa fa-google mr-2"})])}
var staticRenderFns = []

export { render, staticRenderFns }